import React from 'react';
import { AnimatedSkeletonLoader } from '@usepepper/ui/atoms/animated-skeleton-loader';
import { createStyles } from '@/contexts/theme-context';
import { View } from 'react-native';

export const SearchSkeleton = () => {
  const [styles] = useStyles();

  return (
    <View style={styles.searchSkeletonContainer}>
      <AnimatedSkeletonLoader
        borderRadius={8}
        endOpacity={0.15}
        height={38}
        initialOpacity={0.3}
        width={556}
      />
    </View>
  );
};

const useStyles = createStyles(() => ({
  searchSkeletonContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
}));
